// 地図のカスタムスタイル
export const MAP_STYLE = {
  // zoomレベル10以上
  DETAILED: [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [
        { visibility: "off" }
      ]
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        { saturation: -50 }, { lightness: 30 }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [
        { saturation: 50 }, { lightness: 0 }, { hue: 38 }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "labels",
      stylers: [
        { visibility: "on" }, { lightness: 30 }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        { color: "#d4d4d4" }, { visibility: "on" }
      ]
    },
    {
      featureType: "transit.station",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        { saturation: -100 }, { lightness: 30 }
      ]
    },
    {
      featureType: "poi.government",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.attraction",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.business",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.sports_complex",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        { saturation: 30 }, { lightness: -10 }, { hue: "#42ff00" }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        { saturation: -100 }, { lightness: 30 }
      ]
    }
  ],

  // (zoomレベル9以下)
  SIMPLE: [
    {
      featureType: "all",
      elementType: "labels",
      stylers: [
        { visibility: "off" }
      ]
    },
    {
      featureType: "administrative",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [
        { saturation: -100 }, { lightness: 30 }
      ]
    },
    {
      featureType: "road.highway",
      stylers: [
        { visibility: "off" }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry",
      stylers: [
        { color: "#d4d4d4" }, { visibility: "on" }
      ]
    },
    {
      featureType: "transit.station",
      elementType: "labels.icon",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        { saturation: -100 }, { lightness: 30 }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        { saturation: 30 }, { lightness: -10 }, { hue: "#42ff00" }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        { saturation: -100 }, { lightness: 30 }
      ]
    }
  ]
}

// 地図の矩形検索で使用しないパラメータ
export const OMIT_PARAMS = [
  'destination',
  'prefecture',
  'city',
  'major_city',
  'spot_id',
  'lat',
  'lon',
  'radius',
  'sort',
  'limit',
  'offset',
  'page'
]

// 地図のオプション
// @see https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
export const JAPAN_DEFAULT_OPTIONS = {
  clickableIcons: false,
  scrollwheel: true,
  mapTypeControl: false,
  fullscreenControl: false,
  minZoom: 9,
  gestureHandling: 'greedy'
}

export const DEFAULT_OPTIONS = {
  clickableIcons: false,
  scrollwheel: true,
  mapTypeControl: false,
  fullscreenControl: false,
  minZoom: 5,
  gestureHandling: 'greedy'
}

// 県庁所在地の緯度・経度
// FIXME: APIから取得した方がいいかも
export const PREFECTURE_OFFICES = {
  hokkaido: {
    lat: 43.0641666666667,
    lng: 141.346944444444
  },
  aomori: {
    lat: 40.8244444444444,
    lng: 140.74
  },
  iwate: {
    lat: 39.7036111111111,
    lng: 141.1525
  },
  miyagi: {
    lat: 38.2688888888889,
    lng: 140.871944444444
  },
  akita: {
    lat: 39.7180555555556,
    lng: 140.103333333333
  },
  yamagata: {
    lat: 38.2405555555556,
    lng: 140.363333333333
  },
  fukushima: {
    lat: 37.75,
    lng: 140.467777777778
  },
  ibaraki: {
    lat: 36.3413888888889,
    lng: 140.446666666667
  },
  tochigi: {
    lat: 36.5658333333333,
    lng: 139.883611111111
  },
  gunma: {
    lat: 36.3911111111111,
    lng: 139.060833333333
  },
  saitama: {
    lat: 35.8569444444444,
    lng: 139.648888888889
  },
  chiba: {
    lat: 35.6047222222222,
    lng: 140.123333333333
  },
  tokyo: {
    lat: 35.6894444444444,
    lng: 139.691666666667
  },
  kanagawa: {
    lat: 35.4477777777778,
    lng: 139.6425
  },
  niigata: {
    lat: 37.9022222222222,
    lng: 139.023611111111
  },
  toyama: {
    lat: 36.6952777777778,
    lng: 137.211388888889
  },
  ishikawa: {
    lat: 36.5944444444444,
    lng: 136.625555555556
  },
  fukui: {
    lat: 36.0652777777778,
    lng: 136.221944444444
  },
  yamanashi: {
    lat: 35.6638888888889,
    lng: 138.568333333333
  },
  nagano: {
    lat: 36.6513888888889,
    lng: 138.181111111111
  },
  gifu: {
    lat: 35.3911111111111,
    lng: 136.722222222222
  },
  shizuoka: {
    lat: 34.9769444444444,
    lng: 138.383055555556
  },
  aichi: {
    lat: 35.1802777777778,
    lng: 136.906666666667
  },
  mie: {
    lat: 34.7302777777778,
    lng: 136.508611111111
  },
  shiga: {
    lat: 35.0044444444444,
    lng: 135.868333333333
  },
  kyoto: {
    lat: 35.0213888888889,
    lng: 135.755555555556
  },
  osaka: {
    lat: 34.6863888888889,
    lng: 135.52
  },
  hyogo: {
    lat: 34.6913888888889,
    lng: 135.183055555556
  },
  nara: {
    lat: 34.6852777777778,
    lng: 135.832777777778
  },
  wakayama: {
    lat: 34.2261111111111,
    lng: 135.1675
  },
  tottori: {
    lat: 35.5036111111111,
    lng: 134.238333333333
  },
  shimane: {
    lat: 35.4722222222222,
    lng: 133.050555555556
  },
  okayama: {
    lat: 34.6616666666667,
    lng: 133.935
  },
  hiroshima: {
    lat: 34.3963888888889,
    lng: 132.459444444444
  },
  yamaguchi: {
    lat: 34.1858333333333,
    lng: 131.471388888889
  },
  tokushima: {
    lat: 34.0658333333333,
    lng: 134.559444444444
  },
  kagawa: {
    lat: 34.3402777777778,
    lng: 134.043333333333
  },
  ehime: {
    lat: 33.8416666666667,
    lng: 132.766111111111
  },
  kochi: {
    lat: 33.5597222222222,
    lng: 133.531111111111
  },
  fukuoka: {
    lat: 33.6063888888889,
    lng: 130.418055555556
  },
  saga: {
    lat: 33.2494444444444,
    lng: 130.298888888889
  },
  nagasaki: {
    lat: 32.7447222222222,
    lng: 129.873611111111
  },
  kumamoto: {
    lat: 32.7897222222222,
    lng: 130.741666666667
  },
  oita: {
    lat: 33.2380555555556,
    lng: 131.6125
  },
  miyazaki: {
    lat: 31.9111111111111,
    lng: 131.423888888889
  },
  kagoshima: {
    lat: 31.5602777777778,
    lng: 130.558055555556
  },
  okinawa: {
    lat: 26.2125,
    lng: 127.681111111111
  }
}
